/** API host (images and paths served from site root) */
export const API_ORIGIN = 'https://api.mromarelkholy.com';
/** Trailing slash — legacy media URL concatenation (CourseCard, etc.) */
export const BASE_URL = `${API_ORIGIN}/`;
/** REST API base: …/api */
export const API_BASE_URL = `${API_ORIGIN}/api`;
